import { AccountNumberConfig } from 'typings/brands'

// This configuration is temporary, update once received the correct configuration
export const accountNumberConfig: AccountNumberConfig = {
  length: [16, 16]
}
